import { render, staticRenderFns } from "./xp-base.vue?vue&type=template&id=272cd916&scoped=true&"
import script from "./xp-base.vue?vue&type=script&lang=js&"
export * from "./xp-base.vue?vue&type=script&lang=js&"
import style0 from "./xp-base.vue?vue&type=style&index=0&id=272cd916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272cd916",
  null
  
)

export default component.exports